module.exports = __webpack_public_path__ + "img/CloneRigToolControllerDemo.0fadc40b.gif";